import env from '../env';
import * as reporter from './report';

const cookieLoaderIframeId = 'tvv_login_cookie_cross_domain_frame';
const cookiePageUrl = '//video.qq.com/getcookie/cookie.html';

export default class IframeCookieLoader {
  isLoading = false;
  currentLoadingTask = null;
  iframe = null;
  timerOfLoadTimeout;

  constructor() {
    this.initIframe();
  }
  fetch() {
    if (this.hasLoaded()) {
      return Promise.resolve(this.getCookie());
    }
    // NOTICE: 对于并发调用，并未采用真正的队列，只是复用首次调用的结果，成功则都成功，失败则都失败的策略
    // 这里主要考虑到login.init并发调用的场景很少，而且失败概率较低，后续可以优化为真正的队列，每个并发调用失败都不影响后续结果
    if (this.isLoading) {
      return this.currentLoadingTask;
    }

    return this.doLoad();
  }
  doLoad() {
    this.isLoading = true;
    this.iframe.src = cookiePageUrl;

    this.currentLoadingTask = new Promise((resolve) => {
      this.handleLoadTimeout(resolve);
      this.registerCookieLoadedHook(resolve);
      reporter.report({
        f_event: reporter.EVENT_INIT_GETCOOKIE,
      });
    });

    return this.currentLoadingTask;
  }
  reset() {
    this.isLoading = false;
    this.currentLoadingTask = null;
    clearTimeout(this.timerOfLoadTimeout);
  }
  hasLoaded() {
    return !!this.getCookie();
  }
  getCookie() {
    return window.txvCookie || null;
  }
  initIframe() {
    this.iframe = document.getElementById(cookieLoaderIframeId);

    if (!this.iframe) {
      const iframe = document.createElement('iframe');
      iframe.id = cookieLoaderIframeId;
      iframe.style.display = 'none';
      this.iframe = iframe;
      document.body.appendChild(iframe);
    }

    this.iframe.onload = () => {
      this.reset();
      reporter.report({
        f_event: reporter.EVENT_INIT_COOKIE_ONLOAD,
      });
    };
  }
  handleLoadTimeout(resolve) {
    this.timerOfLoadTimeout = setTimeout(() => {
      resolve(this.getCookie());
      this.reset();
      reporter.report({
        f_event: reporter.EVENT_INIT_COOKIE_TIMEOUT,
      });
    }, 3000);
  }
  registerCookieLoadedHook(resolve) {
    window.loadVideoCookie = (cookies) => {
      window.txvCookie = cookies;
      setTimeout(() => {
        resolve(cookies);
        this.reset();
        reporter.report({
          f_event: reporter.EVENT_INIT_COOKIE_LOADED,
        });
      // 经实测发现ios手Q中，注入cookie会有延迟，导致window.loadVideoCookie触发时，通过iframe拿到的cookie仍然会空，因此在手Q中延迟5ms再resolve
      }, env.isIos && env.isMqq ? 5 : 0);
    };
  }
  static instance;
  static getInstance() {
    if (!this.instance) {
      this.instance = new IframeCookieLoader();
    }

    return this.instance;
  }
}
